// @ts-nocheck -- legacy receiving contracts are migrated incrementally below.
import { Dialog } from "@headlessui/react";
import Input from "../../../controls/Input";
import SelectMenu from "../../../controls/SelectMenu";
import { InputNumber } from "primereact/inputnumber";
import { useForm } from "../../useForm";
import { useEffect, useState } from "react";
import { isEmployeeUserType, yesOrNoOptions } from "../../../../shared/utility";

const conditionTypes = [
  { value: 0, label: "Choose Condition" },
  { value: 1, label: "Satisfactory" },
  { value: 2, label: "NOT Satisfactory" },
];
const receivingFieldClassName =
  "mt-1 block w-full rounded-xl border border-[#E2E8F0] bg-white px-3 py-2.5 text-sm text-[#0F172A] shadow-sm transition focus:border-[#2563EB] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/10 disabled:bg-[#F6F8FB] disabled:text-[#64748B]";

const receivingPrimaryButtonClass =
  "inline-flex items-center justify-center rounded-xl border border-[#2563EB] bg-[#2563EB] px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:border-[#1D4ED8] hover:bg-[#1D4ED8]";

const receivingNeutralButtonClass =
  "inline-flex items-center justify-center rounded-xl border border-[#E2E8F0] bg-white px-4 py-2 text-sm font-semibold text-[#0F172A] shadow-sm transition hover:border-[#94A3B8] hover:bg-[#F6F8FB]";

function findConditionOption(value) {
  return (
    conditionTypes.find((c) => c.value === value) || {
      value: 1,
      label: "Satisfactory",
    }
  );
}

function findYesNoOption(value) {
  const raw =
    value != null && typeof value === "object" && "value" in value
      ? value.value
      : value;
  const n = Number(raw);
  const key = Number.isFinite(n) ? n : raw;
  return (
    yesOrNoOptions.find((o) => o.value === key) ?? { value: 0, label: "N/A" }
  );
}

export default function ConfirmPricePopup(props) {
  const { assemblyItem, setNewCostForItem, setOpen, newValues, previousItem } =
    props;

  const [isEmployee, setIsEmployee] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsEmployee(isEmployeeUserType());
  }, []);

  useEffect(() => {
    const mql = window.matchMedia("(max-width: 768px)");
    const handleChange = (e) => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    mql.addEventListener("change", handleChange);
    return () => mql.removeEventListener("change", handleChange);
  }, []);

  const initialFValues = {
    unit_cost: previousItem?.unit_cost || 0,
    lot_number: previousItem?.lot_number || "",
    received_amount: newValues.received_amount || "",
    product_temperature: previousItem?.product_temperature || "",
    product_condition: previousItem?.product_condition
      ? findConditionOption(previousItem.product_condition)
      : { value: 1, label: "Satisfactory" },
    product_quality: previousItem?.product_quality
      ? findConditionOption(previousItem.product_quality)
      : { value: 1, label: "Satisfactory" },
    cfia_meat: previousItem?.cfia_meat
      ? findYesNoOption(previousItem.cfia_meat)
      : { value: 0, label: "N/A" },
    lab_results: previousItem?.lab_results
      ? findYesNoOption(previousItem.lab_results)
      : { value: 0, label: "N/A" },
    is_halal: previousItem?.is_halal
      ? findYesNoOption(previousItem.is_halal)
      : { value: 0, label: "N/A" },
  };

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("lot_number" in fieldValues) {
      temp.lot_number = null;
      const lot =
        fieldValues.lot_number?.trim?.() ?? fieldValues.lot_number ?? "";
      if (!lot) {
        temp.lot_number = "Lot Number is required.";
      }
    }

    if (!isEmployee) {
      if ("unit_cost" in fieldValues) {
        temp.unit_cost = null;
        const costValue = fieldValues.unit_cost?.value ?? fieldValues.unit_cost;
        if (costValue == null || costValue < 0) {
          temp.unit_cost = "Please set unit_cost.";
        }
      }
    }

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === null);
  };

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    false,
    validate,
  );

  const onPriceSet = () => {
    if (validate()) {
      setNewCostForItem({
        ...newValues,
        unit_cost: values.unit_cost,
        lot_number: values.lot_number,
        received_amount: values.received_amount,
        product_temperature: values.product_temperature,
        product_condition: values.product_condition,
        product_quality: values.product_quality,
        cfia_meat: values.cfia_meat,
        lab_results: values.lab_results,
        is_halal: values.is_halal,
      });
      setOpen({
        childComponent: null,
        open: false,
      });
    }
  };

  useEffect(() => {
    setValues((prev) => ({
      ...prev,
      unit_of_measure: assemblyItem?.unit_of_measure,
      received_amount: newValues?.received_amount ?? "",
    }));
  }, []);

  return (
    <div>
      <div>
        <div className="mt-3 text-center sm:mt-5">
          <Dialog.Title
            as="h3"
            className="text-sm font-semibold leading-6 text-[#0F172A]"
          >
            {assemblyItem.manufacturer.label} - {assemblyItem.manufacturer_plu}
          </Dialog.Title>
          <Dialog.Title
            as="h3"
            className="text-sm font-semibold leading-6 text-[#0F172A]"
          >
            {assemblyItem.product_name}
          </Dialog.Title>

          <div
            className={`mt-4 grid gap-4 ${isEmployee ? "grid-cols-1" : "grid-cols-1 sm:grid-cols-2"}`}
          >
            {!isEmployee && (
              <div>
                <Input
                  label="Unit cost"
                  name="unit_cost"
                  onChange={handleInputChange}
                  value={values.unit_cost}
                  labelOn={true}
                  type="number"
                  className={receivingFieldClassName}
                  error={errors.unit_cost}
                />
              </div>
            )}
            <div>
              <Input
                label="Unit of measure"
                name="unit_of_measure"
                onChange={handleInputChange}
                value={values.unit_of_measure}
                labelOn={true}
                disabled={true}
                type="text"
                className={receivingFieldClassName}
              />
            </div>
            <div className="text-start">
              <label className="block text-sm font-medium text-[#334155]">
                Net Weight
              </label>
              <InputNumber
                value={
                  values.received_amount
                    ? parseFloat(values.received_amount)
                    : null
                }
                onValueChange={(e) => {
                  handleInputChange({
                    target: {
                      name: "received_amount",
                      value: e.value !== null ? e.value.toString() : "",
                    },
                  });
                }}
                suffix={
                  values.unit_of_measure ? ` ${values.unit_of_measure}` : " kg"
                }
                min={0}
                maxFractionDigits={3}
                inputClassName={receivingFieldClassName}
                className="w-full"
              />
            </div>
            <div>
              <Input
                label="Lot Number"
                name="lot_number"
                onChange={handleInputChange}
                value={values.lot_number}
                labelOn={true}
                type="text"
                className={receivingFieldClassName}
                error={errors.lot_number}
              />
            </div>
          </div>

          {/* Product Quality Control Section */}
          <div className="mt-4 pt-4">
            <p className="text-sm font-medium text-[#0F172A] mb-3">
              Product Quality Control
            </p>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
              <div>
                <Input
                  label="Product Temperature"
                  name="product_temperature"
                  onChange={handleInputChange}
                  value={values.product_temperature}
                  labelOn={true}
                  type="number"
                  className={receivingFieldClassName}
                  error={errors.product_temperature}
                />
              </div>
              <div>
                <SelectMenu
                  handleInputChange={handleInputChange}
                  name="product_condition"
                  options={conditionTypes}
                  value={values.product_condition}
                  title="Product Condition"
                  menuPortalTarget={document.body}
                />
              </div>
              <div>
                <SelectMenu
                  handleInputChange={handleInputChange}
                  name="product_quality"
                  options={conditionTypes}
                  value={values.product_quality}
                  title="Product Quality"
                  menuPortalTarget={document.body}
                />
              </div>
              <div>
                <SelectMenu
                  handleInputChange={handleInputChange}
                  name="cfia_meat"
                  options={yesOrNoOptions}
                  value={values.cfia_meat}
                  title="CFIA Meat"
                  menuPortalTarget={document.body}
                />
              </div>
              <div>
                <SelectMenu
                  handleInputChange={handleInputChange}
                  name="lab_results"
                  options={yesOrNoOptions}
                  value={values.lab_results}
                  title="Lab Results"
                  menuPortalTarget={document.body}
                  menuPlacement={isMobile ? "top" : undefined}
                />
              </div>
              <div>
                <SelectMenu
                  handleInputChange={handleInputChange}
                  name="is_halal"
                  options={yesOrNoOptions}
                  value={values.is_halal}
                  title="Is Halal"
                  menuPortalTarget={document.body}
                  menuPlacement={isMobile ? "top" : undefined}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
        <button
          type="button"
          className={`${receivingPrimaryButtonClass} w-full py-3 sm:col-start-1 sm:mt-0`}
          onClick={() => {
            onPriceSet();
          }}
        >
          OK
        </button>
      </div>
    </div>
  );
}
